/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Backoffice API
 * Spazious private JSON:API v3 specification
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface Apiv3backofficediagrammingvirtualmetingroomsetuptemplatesDataAttributes
 */
export interface Apiv3backofficediagrammingvirtualmetingroomsetuptemplatesDataAttributes {
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficediagrammingvirtualmetingroomsetuptemplatesDataAttributes
     */
    availabilityStatus?: Apiv3backofficediagrammingvirtualmetingroomsetuptemplatesDataAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficediagrammingvirtualmetingroomsetuptemplatesDataAttributes
     */
    graph: string;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficediagrammingvirtualmetingroomsetuptemplatesDataAttributes
     */
    name: string;
}

/**
    * @export
    * @enum {string}
    */
export enum Apiv3backofficediagrammingvirtualmetingroomsetuptemplatesDataAttributesAvailabilityStatusEnum {
    Disabled = 'disabled',
    Private = 'private',
    Public = 'public'
}

